import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import reducers from './reducers';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import { getToken } from '../config/cookie';
import { api, multipartApi } from '../config/api';
import { setSessionExpired } from './reducers/sessionSlice';

const devMode = process.env.NODE_ENV === 'development';

const tokenMiddleware = store => next => action => {
  const token = getToken();

  if (action.error && action?.payload) {
    console.error('Error caught :: > ', action?.payload);
  }

  const isNotAuth = !action?.type?.startsWith('auth');
  const isNotLogin = !action?.type?.startsWith('login');
  const isNotRegistration = !action?.type?.startsWith('registration');
  const isNotToken = token !== null;

  if (isNotAuth && isNotLogin && isNotRegistration && isNotToken) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    multipartApi.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }

  if (
    action.error &&
    action?.payload?.errorMessage &&
    action?.payload?.errorMessage.toString().includes('JWT')
  ) {
    store.dispatch(setSessionExpired());
  } else {
    return next(action);
  }
};

const middlewares = [
  ...getDefaultMiddleware({
    serializableCheck: {
      // Ignore these action paths in the serializability check
      ignoredActionPaths: ['payload.headers']
    }
  }),
  tokenMiddleware,
  thunk
  // ,
  // devMode && logger
].filter(Boolean);

export const store = configureStore({
  reducer: reducers,
  middleware: middlewares,
  devTools: devMode
});
